export const DEFAULT_LANGUAGE = 'en';

export const LANGUAGE_LABELS = Object.freeze({
  en: 'English',
  de: 'Deutsch',
  fr: 'Français',
  es: 'Español',
  it: 'Italiano'
});

export const translations = Object.freeze({
  en: {
    "text.button": "TEXT",
    "text.title": "Text message",
    "text.message": "Message",
    "text.close": "Close message",
    "text.actions": "Send a message to Command",
    "text.sentBody": "Your message is now in Command notifications.",
    "text.sendFailed": "Could not send. Your message is kept here so you can try again.",
    "text.tooLong": "Messages may contain up to 2000 characters.",
    'voice.record': 'RECORD',
    'voice.title': 'Voice recording',
    'voice.requesting': 'Allow microphone access to start recording…',
    'voice.limit': 'Up to 2 minutes',
    'voice.stop': 'Stop and preview',
    'voice.preview': 'Listen before sending.',
    'voice.name': 'Your name (optional)',
    'voice.sent': 'Sent to Command',
    'voice.sentBody': 'Your recording is now in Command notifications.',
    'voice.retry': 'Try recording again',
    'voice.discard': 'Discard',
    'voice.again': 'Record again',
    'voice.sending': 'Sending…',
    'voice.send': 'Send to Command',
    'voice.permissionDenied': 'Microphone access is blocked. Allow it in your browser settings and try again.',
    'voice.microphoneUnavailable': 'The microphone could not be opened. Check it and try again.',
    'voice.sessionEnded': 'This LIVE link or session is no longer active.',
    'voice.unsupported': 'Voice recording is unavailable in this browser.',
    'voice.empty': 'No recording was captured. Try again.',
    'voice.tooLarge': 'This recording is too large. Try a shorter message.',
    'voice.tryLater': 'Delivery is busy. Wait a moment and send again.',
    'voice.sendFailed': 'Could not send. Your recording is kept here so you can try again.',
    'viewer.view': 'View',
    'settings.title': 'Settings',
    'settings.close': 'Close settings',
    'settings.appearance': 'Appearance',
    'settings.dark': 'Dark',
    'settings.light': 'Light',
    'settings.mapDisplay': 'Map display',
    'settings.featureLabels': 'Feature labels',
    'settings.trackerLabels': 'Tracker labels',
    'settings.teamLabels': 'Team labels',
    'settings.trails': 'Recent tracker trails',
    'settings.teamAreas': 'Team areas',
    'settings.labelSize': 'Label size',
    'settings.saved': 'Saved on this device',
    'settings.done': 'Done',
    'viewer.inspect': 'Inspect session',
    'viewer.navigation': 'Navigation',
    'viewer.zoomIn': 'Zoom in',
    'viewer.zoomOut': 'Zoom out',
    'viewer.resetNorth': 'Reset bearing and pitch',
    'viewer.emptyTeams': 'No teams in this session.',
    'viewer.teamPositions': '{count}/{total} trackers positioned',
    'viewer.teamAtArea': 'Shown at the assigned area until a position is available.',
    'app.title': 'LIVE',
    'app.tagline': 'Follow the operation. Read only. Updated live.',
    'app.readOnly': 'Read-only map',
    'app.language': 'Language',
    'app.newSession': 'Open another session',
    'app.about': 'CYNOOPS LIVE securely displays a shared Command session. It cannot change the operation map.',
    'install.action': 'Install LIVE',
    'install.title': 'Add LIVE to your Home Screen',
    'install.ios': 'Tap Share, then choose “Add to Home Screen”.',
    'install.done': 'Got it',
    'scan.title': 'Open a live session',
    'scan.camera': 'Scan QR code',
    'scan.cameraActive': 'Point the camera at the QR code',
    'scan.starting': 'Starting camera…',
    'scan.stopCamera': 'Stop',
    'scan.import': 'Choose QR image',
    'scan.importHint': 'Drop or paste',
    'scan.reading': 'Reading QR image…',
    'scan.manualToggle': 'Enter link instead',
    'scan.manualLabel': 'LIVE link',
    'scan.manualPlaceholder': 'Paste LIVE link',
    'scan.open': 'Open',
    'scan.noCamera': 'No camera found. Choose a QR image.',
    'scan.cameraDenied': 'Camera access blocked. Choose a QR image.',
    'scan.invalid': 'Invalid CYNOOPS LIVE QR code or link.',
    'scan.imageFailed': 'No QR code found in this image.',
    'loading.title': 'Opening live session',
    'loading.body': 'Verifying the secure link and loading the map…',
    'error.title': 'Session unavailable',
    'error.invalid': 'This secure link is invalid.',
    'error.expired': 'This secure link has expired.',
    'error.revoked': 'This secure link was revoked in Command.',
    'error.missing': 'The shared session no longer exists.',
    'error.network': 'LIVE could not reach the session. Check your connection and try again.',
    'error.generic': 'The session could not be opened.',
    'error.retry': 'Try again',
    'viewer.live': 'Live',
    'viewer.ended': 'Ended',
    'viewer.updating': 'Updating',
    'viewer.updated': 'Updated {time}',
    'viewer.stale': 'Connection interrupted · showing last update',
    'viewer.mapStyle': 'Map style',
    'viewer.street': 'Street',
    'viewer.terrain': 'Terrain',
    'viewer.satellite': 'Satellite',
    'viewer.features': 'Features',
    'viewer.trackers': 'Trackers',
    'viewer.teams': 'Teams',
    'viewer.hidePanel': 'Hide information panel',
    'viewer.showPanel': 'Show information panel',
    'viewer.fit': 'Fit session on map',
    'viewer.closeView': 'Close live session view',
    'viewer.closeConfirmTitle': 'Close this live view?',
    'viewer.closeConfirmBody': 'You will return to scan or import a session QR code. This does not stop the active session in Command.',
    'viewer.closeConfirmCancel': 'Keep viewing',
    'viewer.closeConfirmAction': 'Close view',
    'viewer.emptyFeatures': 'No map features in this session.',
    'viewer.emptyTrackers': 'No trackers in this session.',
    'viewer.feature': 'Feature',
    'viewer.tracker': 'Tracker',
    'viewer.team': 'Team',
    'viewer.battery': 'Battery',
    'viewer.speed': 'Speed',
    'viewer.altitude': 'Altitude',
    'viewer.lastPosition': 'Last position',
    'viewer.noPosition': 'Waiting for position',
    'viewer.sessionId': 'Session ID',
    'viewer.started': 'Started',
    'viewer.finished': 'Finished',
    'viewer.mapUnavailable': 'The map configuration is unavailable for this share.',
    'viewer.mapLoading': 'Loading Mapbox map…',
    'viewer.mapError': 'Mapbox could not load the map.',
    'time.now': 'just now',
    'time.seconds': '{count}s ago',
    'time.minutes': '{count}m ago',
    'time.hours': '{count}h ago'
  },
  de: {
    "text.button": "TEXT",
    "text.title": "Textnachricht",
    "text.message": "Nachricht",
    "text.close": "Nachricht schließen",
    "text.actions": "Nachricht an Command senden",
    "text.sentBody": "Deine Nachricht ist jetzt in den Command-Benachrichtigungen.",
    "text.sendFailed": "Senden fehlgeschlagen. Deine Nachricht bleibt hier für einen erneuten Versuch.",
    "text.tooLong": "Nachrichten dürfen bis zu 2000 Zeichen enthalten.",
    'voice.record': 'AUFNEHMEN',
    'voice.title': 'Sprachaufnahme',
    'voice.requesting': 'Mikrofonzugriff erlauben, um aufzunehmen…',
    'voice.limit': 'Bis zu 2 Minuten',
    'voice.stop': 'Stoppen und anhören',
    'voice.preview': 'Vor dem Senden anhören.',
    'voice.name': 'Dein Name (optional)',
    'voice.sent': 'An Command gesendet',
    'voice.sentBody': 'Deine Aufnahme ist jetzt in den Command-Benachrichtigungen.',
    'voice.retry': 'Aufnahme erneut versuchen',
    'voice.discard': 'Verwerfen',
    'voice.again': 'Erneut aufnehmen',
    'voice.sending': 'Wird gesendet…',
    'voice.send': 'An Command senden',
    'voice.permissionDenied': 'Der Mikrofonzugriff ist blockiert. Erlaube ihn in den Browsereinstellungen und versuche es erneut.',
    'voice.microphoneUnavailable': 'Das Mikrofon konnte nicht geöffnet werden. Prüfe es und versuche es erneut.',
    'voice.sessionEnded': 'Dieser LIVE-Link oder die Sitzung ist nicht mehr aktiv.',
    'voice.unsupported': 'Sprachaufnahmen sind in diesem Browser nicht verfügbar.',
    'voice.empty': 'Keine Aufnahme erfasst. Versuche es erneut.',
    'voice.tooLarge': 'Die Aufnahme ist zu groß. Nimm eine kürzere Nachricht auf.',
    'voice.tryLater': 'Die Übertragung ist ausgelastet. Warte kurz und sende erneut.',
    'voice.sendFailed': 'Senden fehlgeschlagen. Deine Aufnahme bleibt hier für einen erneuten Versuch.',
    'viewer.view': 'Ansicht',
    'settings.title': 'Einstellungen',
    'settings.close': 'Einstellungen schließen',
    'settings.appearance': 'Darstellung',
    'settings.dark': 'Dunkel',
    'settings.light': 'Hell',
    'settings.mapDisplay': 'Kartenansicht',
    'settings.featureLabels': 'Objektbeschriftungen',
    'settings.trackerLabels': 'Tracker-Beschriftungen',
    'settings.teamLabels': 'Teambeschriftungen',
    'settings.trails': 'Letzte Tracker-Positionen',
    'settings.teamAreas': 'Teambereiche',
    'settings.labelSize': 'Beschriftungsgröße',
    'settings.saved': 'Auf diesem Gerät gespeichert',
    'settings.done': 'Fertig',
    'viewer.inspect': 'Sitzung ansehen',
    'viewer.navigation': 'Navigation',
    'viewer.zoomIn': 'Vergrößern',
    'viewer.zoomOut': 'Verkleinern',
    'viewer.resetNorth': 'Ausrichtung und Neigung zurücksetzen',
    'viewer.emptyTeams': 'Keine Teams in dieser Sitzung.',
    'viewer.teamPositions': '{count}/{total} Tracker mit Position',
    'viewer.teamAtArea': 'Anzeige im zugewiesenen Gebiet, bis eine Position verfügbar ist.',
    'app.title': 'LIVE',
    'app.tagline': 'Einsatz verfolgen. Schreibgeschützt. Live aktualisiert.',
    'app.readOnly': 'Schreibgeschützte Karte',
    'app.language': 'Sprache',
    'app.newSession': 'Andere Sitzung öffnen',
    'app.about': 'CYNOOPS LIVE zeigt eine freigegebene Command-Sitzung sicher an. Die Einsatzkarte kann nicht verändert werden.',
    'install.action': 'LIVE installieren',
    'install.title': 'LIVE zum Home-Bildschirm hinzufügen',
    'install.ios': 'Tippe auf „Teilen“ und dann auf „Zum Home-Bildschirm“.',
    'install.done': 'Verstanden',
    'scan.title': 'Live-Sitzung öffnen',
    'scan.camera': 'QR-Code scannen',
    'scan.cameraActive': 'Kamera auf den QR-Code richten',
    'scan.starting': 'Kamera wird gestartet…',
    'scan.stopCamera': 'Stoppen',
    'scan.import': 'QR-Bild auswählen',
    'scan.importHint': 'Ablegen oder einfügen',
    'scan.reading': 'QR-Bild wird gelesen…',
    'scan.manualToggle': 'Stattdessen Link eingeben',
    'scan.manualLabel': 'LIVE-Link',
    'scan.manualPlaceholder': 'LIVE-Link einfügen',
    'scan.open': 'Öffnen',
    'scan.noCamera': 'Keine Kamera gefunden. QR-Bild auswählen.',
    'scan.cameraDenied': 'Kamerazugriff blockiert. QR-Bild auswählen.',
    'scan.invalid': 'Ungültiger CYNOOPS-LIVE-QR-Code oder -Link.',
    'scan.imageFailed': 'Kein QR-Code in diesem Bild gefunden.',
    'loading.title': 'Live-Sitzung wird geöffnet',
    'loading.body': 'Sicherer Link wird geprüft und die Karte geladen…',
    'error.title': 'Sitzung nicht verfügbar',
    'error.invalid': 'Dieser sichere Link ist ungültig.',
    'error.expired': 'Dieser sichere Link ist abgelaufen.',
    'error.revoked': 'Dieser sichere Link wurde in Command widerrufen.',
    'error.missing': 'Die freigegebene Sitzung existiert nicht mehr.',
    'error.network': 'LIVE konnte die Sitzung nicht erreichen. Verbindung prüfen und erneut versuchen.',
    'error.generic': 'Die Sitzung konnte nicht geöffnet werden.',
    'error.retry': 'Erneut versuchen',
    'viewer.live': 'Live',
    'viewer.ended': 'Beendet',
    'viewer.updating': 'Aktualisierung',
    'viewer.updated': 'Aktualisiert {time}',
    'viewer.stale': 'Verbindung unterbrochen · letzter Stand wird angezeigt',
    'viewer.mapStyle': 'Kartenstil',
    'viewer.street': 'Straße',
    'viewer.terrain': 'Gelände',
    'viewer.satellite': 'Satellit',
    'viewer.features': 'Objekte',
    'viewer.trackers': 'Tracker',
    'viewer.teams': 'Teams',
    'viewer.hidePanel': 'Informationsbereich ausblenden',
    'viewer.showPanel': 'Informationsbereich anzeigen',
    'viewer.fit': 'Sitzung auf Karte einpassen',
    'viewer.closeView': 'Live-Sitzungsansicht schließen',
    'viewer.closeConfirmTitle': 'Diese Live-Ansicht schließen?',
    'viewer.closeConfirmBody': 'Du kehrst zur Seite zurück, auf der du einen Sitzungs-QR-Code scannen oder importieren kannst. Die aktive Sitzung in Command wird dadurch nicht beendet.',
    'viewer.closeConfirmCancel': 'Ansicht geöffnet lassen',
    'viewer.closeConfirmAction': 'Ansicht schließen',
    'viewer.emptyFeatures': 'Keine Kartenobjekte in dieser Sitzung.',
    'viewer.emptyTrackers': 'Keine Tracker in dieser Sitzung.',
    'viewer.feature': 'Objekt',
    'viewer.tracker': 'Tracker',
    'viewer.team': 'Team',
    'viewer.battery': 'Akku',
    'viewer.speed': 'Geschwindigkeit',
    'viewer.altitude': 'Höhe',
    'viewer.lastPosition': 'Letzte Position',
    'viewer.noPosition': 'Position wird erwartet',
    'viewer.sessionId': 'Sitzungs-ID',
    'viewer.started': 'Begonnen',
    'viewer.finished': 'Beendet',
    'viewer.mapUnavailable': 'Für diese Freigabe ist keine Kartenkonfiguration verfügbar.',
    'viewer.mapLoading': 'Mapbox-Karte wird geladen…',
    'viewer.mapError': 'Mapbox konnte die Karte nicht laden.',
    'time.now': 'gerade eben',
    'time.seconds': 'vor {count}s',
    'time.minutes': 'vor {count} Min.',
    'time.hours': 'vor {count} Std.'
  },
  fr: {
    "text.button": "TEXTE",
    "text.title": "Message texte",
    "text.message": "Message",
    "text.close": "Fermer le message",
    "text.actions": "Envoyer un message à Command",
    "text.sentBody": "Votre message apparaît dans les notifications de Command.",
    "text.sendFailed": "Envoi impossible. Votre message est conservé pour réessayer.",
    "text.tooLong": "Les messages peuvent contenir jusqu’à 2000 caractères.",
    'voice.record': 'ENREGISTRER',
    'voice.title': 'Message vocal',
    'voice.requesting': 'Autorisez le microphone pour enregistrer…',
    'voice.limit': 'Jusqu’à 2 minutes',
    'voice.stop': 'Arrêter et écouter',
    'voice.preview': 'Écoutez avant d’envoyer.',
    'voice.name': 'Votre nom (facultatif)',
    'voice.sent': 'Envoyé à Command',
    'voice.sentBody': 'Votre enregistrement apparaît dans les notifications de Command.',
    'voice.retry': 'Réessayer l’enregistrement',
    'voice.discard': 'Supprimer',
    'voice.again': 'Réenregistrer',
    'voice.sending': 'Envoi…',
    'voice.send': 'Envoyer à Command',
    'voice.permissionDenied': 'L’accès au microphone est bloqué. Autorisez-le dans les paramètres du navigateur et réessayez.',
    'voice.microphoneUnavailable': 'Impossible d’ouvrir le microphone. Vérifiez-le et réessayez.',
    'voice.sessionEnded': 'Ce lien LIVE ou cette session n’est plus actif.',
    'voice.unsupported': 'L’enregistrement vocal n’est pas disponible dans ce navigateur.',
    'voice.empty': 'Aucun enregistrement reçu. Réessayez.',
    'voice.tooLarge': 'Enregistrement trop volumineux. Essayez un message plus court.',
    'voice.tryLater': 'L’envoi est occupé. Patientez un instant puis réessayez.',
    'voice.sendFailed': 'Envoi impossible. Votre enregistrement est conservé ici pour réessayer.',
    'viewer.view': 'Vue',
    'settings.title': 'Paramètres',
    'settings.close': 'Fermer les paramètres',
    'settings.appearance': 'Apparence',
    'settings.dark': 'Sombre',
    'settings.light': 'Clair',
    'settings.mapDisplay': 'Affichage de la carte',
    'settings.featureLabels': 'Libellés des éléments',
    'settings.trackerLabels': 'Libellés des traceurs',
    'settings.teamLabels': 'Libellés des équipes',
    'settings.trails': 'Traces récentes',
    'settings.teamAreas': 'Zones des équipes',
    'settings.labelSize': 'Taille des libellés',
    'settings.saved': 'Enregistré sur cet appareil',
    'settings.done': 'Terminé',
    'viewer.inspect': 'Consulter la session',
    'viewer.navigation': 'Navigation',
    'viewer.zoomIn': 'Zoom avant',
    'viewer.zoomOut': 'Zoom arrière',
    'viewer.resetNorth': 'Réinitialiser l’orientation et l’inclinaison',
    'viewer.emptyTeams': 'Aucune équipe dans cette session.',
    'viewer.teamPositions': '{count}/{total} traceurs localisés',
    'viewer.teamAtArea': 'Affichée dans la zone attribuée en attendant une position.',
    'app.title': 'LIVE',
    'app.tagline': "Suivez l'opération. Lecture seule. Mise à jour en direct.",
    'app.readOnly': 'Carte en lecture seule',
    'app.language': 'Langue',
    'app.newSession': 'Ouvrir une autre session',
    'app.about': "CYNOOPS LIVE affiche en toute sécurité une session Command partagée. Il ne peut pas modifier la carte de l'opération.",
    'install.action': 'Installer LIVE',
    'install.title': 'Ajouter LIVE à l’écran d’accueil',
    'install.ios': 'Touchez Partager, puis « Sur l’écran d’accueil ».',
    'install.done': 'Compris',
    'scan.title': 'Ouvrir une session en direct',
    'scan.camera': 'Scanner le QR code',
    'scan.cameraActive': 'Dirigez la caméra vers le QR code',
    'scan.starting': 'Démarrage de la caméra…',
    'scan.stopCamera': 'Arrêter',
    'scan.import': 'Choisir une image QR',
    'scan.importHint': 'Déposer ou coller',
    'scan.reading': 'Lecture de l’image QR…',
    'scan.manualToggle': 'Saisir le lien à la place',
    'scan.manualLabel': 'Lien LIVE',
    'scan.manualPlaceholder': 'Collez le lien LIVE',
    'scan.open': 'Ouvrir',
    'scan.noCamera': 'Aucune caméra détectée. Choisissez une image QR.',
    'scan.cameraDenied': 'Accès à la caméra bloqué. Choisissez une image QR.',
    'scan.invalid': 'QR code ou lien CYNOOPS LIVE non valide.',
    'scan.imageFailed': 'Aucun QR code trouvé dans cette image.',
    'loading.title': 'Ouverture de la session en direct',
    'loading.body': 'Vérification du lien sécurisé et chargement de la carte…',
    'error.title': 'Session indisponible',
    'error.invalid': "Ce lien sécurisé n'est pas valide.",
    'error.expired': 'Ce lien sécurisé a expiré.',
    'error.revoked': 'Ce lien sécurisé a été révoqué dans Command.',
    'error.missing': "La session partagée n'existe plus.",
    'error.network': "LIVE ne peut pas joindre la session. Vérifiez votre connexion et réessayez.",
    'error.generic': "Impossible d'ouvrir la session.",
    'error.retry': 'Réessayer',
    'viewer.live': 'En direct',
    'viewer.ended': 'Terminée',
    'viewer.updating': 'Mise à jour',
    'viewer.updated': 'Mis à jour {time}',
    'viewer.stale': 'Connexion interrompue · dernière mise à jour affichée',
    'viewer.mapStyle': 'Style de carte',
    'viewer.street': 'Plan',
    'viewer.terrain': 'Terrain',
    'viewer.satellite': 'Satellite',
    'viewer.features': 'Éléments',
    'viewer.trackers': 'Traceurs',
    'viewer.teams': 'Équipes',
    'viewer.hidePanel': "Masquer le panneau d'information",
    'viewer.showPanel': "Afficher le panneau d'information",
    'viewer.fit': 'Ajuster la session à la carte',
    'viewer.closeView': 'Fermer la vue de session en direct',
    'viewer.closeConfirmTitle': 'Fermer cette vue en direct ?',
    'viewer.closeConfirmBody': "Vous reviendrez à la page permettant de scanner ou d'importer le QR code d'une session. Cela n'arrête pas la session active dans Command.",
    'viewer.closeConfirmCancel': 'Continuer à regarder',
    'viewer.closeConfirmAction': 'Fermer la vue',
    'viewer.emptyFeatures': 'Aucun élément cartographique dans cette session.',
    'viewer.emptyTrackers': 'Aucun traceur dans cette session.',
    'viewer.feature': 'Élément',
    'viewer.tracker': 'Traceur',
    'viewer.team': 'Équipe',
    'viewer.battery': 'Batterie',
    'viewer.speed': 'Vitesse',
    'viewer.altitude': 'Altitude',
    'viewer.lastPosition': 'Dernière position',
    'viewer.noPosition': 'En attente de position',
    'viewer.sessionId': 'ID de session',
    'viewer.started': 'Démarrée',
    'viewer.finished': 'Terminée',
    'viewer.mapUnavailable': "La configuration de carte n'est pas disponible pour ce partage.",
    'viewer.mapLoading': 'Chargement de la carte Mapbox…',
    'viewer.mapError': "Mapbox n'a pas pu charger la carte.",
    'time.now': "à l'instant",
    'time.seconds': 'il y a {count}s',
    'time.minutes': 'il y a {count}min',
    'time.hours': 'il y a {count}h'
  },
  es: {
    "text.button": "TEXTO",
    "text.title": "Mensaje de texto",
    "text.message": "Mensaje",
    "text.close": "Cerrar mensaje",
    "text.actions": "Enviar un mensaje a Command",
    "text.sentBody": "Tu mensaje ya está en las notificaciones de Command.",
    "text.sendFailed": "No se pudo enviar. Tu mensaje se conserva para volver a intentarlo.",
    "text.tooLong": "Los mensajes pueden contener hasta 2000 caracteres.",
    'voice.record': 'GRABAR',
    'voice.title': 'Grabación de voz',
    'voice.requesting': 'Permite el acceso al micrófono para grabar…',
    'voice.limit': 'Hasta 2 minutos',
    'voice.stop': 'Detener y escuchar',
    'voice.preview': 'Escucha antes de enviar.',
    'voice.name': 'Tu nombre (opcional)',
    'voice.sent': 'Enviado a Command',
    'voice.sentBody': 'Tu grabación aparece en las notificaciones de Command.',
    'voice.retry': 'Volver a intentar',
    'voice.discard': 'Descartar',
    'voice.again': 'Grabar de nuevo',
    'voice.sending': 'Enviando…',
    'voice.send': 'Enviar a Command',
    'voice.permissionDenied': 'El acceso al micrófono está bloqueado. Permítelo en la configuración del navegador y vuelve a intentarlo.',
    'voice.microphoneUnavailable': 'No se pudo abrir el micrófono. Revísalo y vuelve a intentarlo.',
    'voice.sessionEnded': 'Este enlace LIVE o esta sesión ya no está activo.',
    'voice.unsupported': 'La grabación de voz no está disponible en este navegador.',
    'voice.empty': 'No se capturó ninguna grabación. Vuelve a intentarlo.',
    'voice.tooLarge': 'La grabación es demasiado grande. Prueba un mensaje más corto.',
    'voice.tryLater': 'El envío está ocupado. Espera un momento y vuelve a intentarlo.',
    'voice.sendFailed': 'No se pudo enviar. La grabación se conserva aquí para volver a intentarlo.',
    'viewer.view': 'Vista',
    'settings.title': 'Configuración',
    'settings.close': 'Cerrar configuración',
    'settings.appearance': 'Apariencia',
    'settings.dark': 'Oscuro',
    'settings.light': 'Claro',
    'settings.mapDisplay': 'Vista del mapa',
    'settings.featureLabels': 'Etiquetas de elementos',
    'settings.trackerLabels': 'Etiquetas de rastreadores',
    'settings.teamLabels': 'Etiquetas de equipos',
    'settings.trails': 'Recorridos recientes',
    'settings.teamAreas': 'Zonas de equipos',
    'settings.labelSize': 'Tamaño de etiquetas',
    'settings.saved': 'Guardado en este dispositivo',
    'settings.done': 'Listo',
    'viewer.inspect': 'Consultar sesión',
    'viewer.navigation': 'Navegación',
    'viewer.zoomIn': 'Acercar',
    'viewer.zoomOut': 'Alejar',
    'viewer.resetNorth': 'Restablecer orientación e inclinación',
    'viewer.emptyTeams': 'No hay equipos en esta sesión.',
    'viewer.teamPositions': '{count}/{total} rastreadores localizados',
    'viewer.teamAtArea': 'Se muestra en la zona asignada hasta recibir una posición.',
    'app.title': 'LIVE',
    'app.tagline': 'Sigue la operación. Solo lectura. Actualización en directo.',
    'app.readOnly': 'Mapa de solo lectura',
    'app.language': 'Idioma',
    'app.newSession': 'Abrir otra sesión',
    'app.about': 'CYNOOPS LIVE muestra de forma segura una sesión compartida de Command. No puede modificar el mapa operativo.',
    'install.action': 'Instalar LIVE',
    'install.title': 'Añadir LIVE a la pantalla de inicio',
    'install.ios': 'Toca Compartir y luego «Añadir a pantalla de inicio».',
    'install.done': 'Entendido',
    'scan.title': 'Abrir una sesión en directo',
    'scan.camera': 'Escanear QR',
    'scan.cameraActive': 'Apunta la cámara al código QR',
    'scan.starting': 'Iniciando cámara…',
    'scan.stopCamera': 'Detener',
    'scan.import': 'Elegir imagen QR',
    'scan.importHint': 'Suelta o pega',
    'scan.reading': 'Leyendo imagen QR…',
    'scan.manualToggle': 'Introducir enlace',
    'scan.manualLabel': 'Enlace LIVE',
    'scan.manualPlaceholder': 'Pega el enlace LIVE',
    'scan.open': 'Abrir',
    'scan.noCamera': 'No se detectó ninguna cámara. Elige una imagen QR.',
    'scan.cameraDenied': 'Acceso a la cámara bloqueado. Elige una imagen QR.',
    'scan.invalid': 'Código QR o enlace de CYNOOPS LIVE no válido.',
    'scan.imageFailed': 'No se encontró ningún QR en esta imagen.',
    'loading.title': 'Abriendo sesión en directo',
    'loading.body': 'Verificando el enlace seguro y cargando el mapa…',
    'error.title': 'Sesión no disponible',
    'error.invalid': 'Este enlace seguro no es válido.',
    'error.expired': 'Este enlace seguro ha caducado.',
    'error.revoked': 'Este enlace seguro fue revocado en Command.',
    'error.missing': 'La sesión compartida ya no existe.',
    'error.network': 'LIVE no pudo conectar con la sesión. Comprueba la conexión e inténtalo de nuevo.',
    'error.generic': 'No se pudo abrir la sesión.',
    'error.retry': 'Intentar de nuevo',
    'viewer.live': 'En directo',
    'viewer.ended': 'Finalizada',
    'viewer.updating': 'Actualizando',
    'viewer.updated': 'Actualizado {time}',
    'viewer.stale': 'Conexión interrumpida · mostrando la última actualización',
    'viewer.mapStyle': 'Estilo de mapa',
    'viewer.street': 'Calles',
    'viewer.terrain': 'Terreno',
    'viewer.satellite': 'Satélite',
    'viewer.features': 'Elementos',
    'viewer.trackers': 'Rastreadores',
    'viewer.teams': 'Equipos',
    'viewer.hidePanel': 'Ocultar panel de información',
    'viewer.showPanel': 'Mostrar panel de información',
    'viewer.fit': 'Ajustar la sesión al mapa',
    'viewer.closeView': 'Cerrar la vista de sesión en directo',
    'viewer.closeConfirmTitle': '¿Cerrar esta vista en directo?',
    'viewer.closeConfirmBody': 'Volverás a la página donde puedes escanear o importar el código QR de una sesión. Esto no detiene la sesión activa en Command.',
    'viewer.closeConfirmCancel': 'Seguir viendo',
    'viewer.closeConfirmAction': 'Cerrar vista',
    'viewer.emptyFeatures': 'No hay elementos en el mapa de esta sesión.',
    'viewer.emptyTrackers': 'No hay rastreadores en esta sesión.',
    'viewer.feature': 'Elemento',
    'viewer.tracker': 'Rastreador',
    'viewer.team': 'Equipo',
    'viewer.battery': 'Batería',
    'viewer.speed': 'Velocidad',
    'viewer.altitude': 'Altitud',
    'viewer.lastPosition': 'Última posición',
    'viewer.noPosition': 'Esperando posición',
    'viewer.sessionId': 'ID de sesión',
    'viewer.started': 'Iniciada',
    'viewer.finished': 'Finalizada',
    'viewer.mapUnavailable': 'La configuración del mapa no está disponible para este enlace.',
    'viewer.mapLoading': 'Cargando mapa de Mapbox…',
    'viewer.mapError': 'Mapbox no pudo cargar el mapa.',
    'time.now': 'ahora mismo',
    'time.seconds': 'hace {count}s',
    'time.minutes': 'hace {count}min',
    'time.hours': 'hace {count}h'
  },
  it: {
    "text.button": "TESTO",
    "text.title": "Messaggio di testo",
    "text.message": "Messaggio",
    "text.close": "Chiudi messaggio",
    "text.actions": "Invia un messaggio a Command",
    "text.sentBody": "Il messaggio è ora nelle notifiche di Command.",
    "text.sendFailed": "Invio non riuscito. Il messaggio è conservato per riprovare.",
    "text.tooLong": "I messaggi possono contenere fino a 2000 caratteri.",
    'voice.record': 'REGISTRA',
    'voice.title': 'Messaggio vocale',
    'voice.requesting': 'Consenti il microfono per registrare…',
    'voice.limit': 'Fino a 2 minuti',
    'voice.stop': 'Ferma e ascolta',
    'voice.preview': 'Ascolta prima di inviare.',
    'voice.name': 'Il tuo nome (facoltativo)',
    'voice.sent': 'Inviato a Command',
    'voice.sentBody': 'La registrazione è nelle notifiche di Command.',
    'voice.retry': 'Riprova a registrare',
    'voice.discard': 'Scarta',
    'voice.again': 'Registra di nuovo',
    'voice.sending': 'Invio…',
    'voice.send': 'Invia a Command',
    'voice.permissionDenied': 'L’accesso al microfono è bloccato. Consentilo nelle impostazioni del browser e riprova.',
    'voice.microphoneUnavailable': 'Impossibile aprire il microfono. Controllalo e riprova.',
    'voice.sessionEnded': 'Questo link LIVE o la sessione non è più attivo.',
    'voice.unsupported': 'La registrazione vocale non è disponibile in questo browser.',
    'voice.empty': 'Nessuna registrazione acquisita. Riprova.',
    'voice.tooLarge': 'La registrazione è troppo grande. Prova un messaggio più breve.',
    'voice.tryLater': 'L’invio è occupato. Attendi un momento e riprova.',
    'voice.sendFailed': 'Invio non riuscito. La registrazione rimane qui per riprovare.',
    'viewer.view': 'Vista',
    'settings.title': 'Impostazioni',
    'settings.close': 'Chiudi impostazioni',
    'settings.appearance': 'Aspetto',
    'settings.dark': 'Scuro',
    'settings.light': 'Chiaro',
    'settings.mapDisplay': 'Visualizzazione mappa',
    'settings.featureLabels': 'Etichette degli elementi',
    'settings.trackerLabels': 'Etichette dei tracker',
    'settings.teamLabels': 'Etichette delle squadre',
    'settings.trails': 'Tracce recenti',
    'settings.teamAreas': 'Aree delle squadre',
    'settings.labelSize': 'Dimensione etichette',
    'settings.saved': 'Salvato su questo dispositivo',
    'settings.done': 'Fine',
    'viewer.inspect': 'Consulta sessione',
    'viewer.navigation': 'Navigazione',
    'viewer.zoomIn': 'Ingrandisci',
    'viewer.zoomOut': 'Riduci',
    'viewer.resetNorth': 'Ripristina orientamento e inclinazione',
    'viewer.emptyTeams': 'Nessuna squadra in questa sessione.',
    'viewer.teamPositions': '{count}/{total} tracker localizzati',
    'viewer.teamAtArea': 'Mostrata nell’area assegnata in attesa di una posizione.',
    'app.title': 'LIVE',
    'app.tagline': "Segui l'operazione. Sola lettura. Aggiornata in diretta.",
    'app.readOnly': 'Vista in sola lettura',
    'app.language': 'Lingua',
    'app.newSession': "Apri un'altra sessione",
    'app.about': 'CYNOOPS LIVE mostra in modo sicuro una sessione Command condivisa. Non può modificare la mappa operativa.',
    'install.action': 'Installa LIVE',
    'install.title': 'Aggiungi LIVE alla schermata Home',
    'install.ios': 'Tocca Condividi, poi «Aggiungi alla schermata Home».',
    'install.done': 'Ho capito',
    'scan.title': 'Apri una sessione live',
    'scan.camera': 'Scansiona QR',
    'scan.cameraActive': 'Inquadra il codice QR',
    'scan.starting': 'Avvio fotocamera…',
    'scan.stopCamera': 'Ferma',
    'scan.import': 'Scegli immagine QR',
    'scan.importHint': 'Trascina o incolla',
    'scan.reading': 'Lettura immagine QR…',
    'scan.manualToggle': 'Inserisci il link',
    'scan.manualLabel': 'Link LIVE',
    'scan.manualPlaceholder': 'Incolla il link LIVE',
    'scan.open': 'Apri',
    'scan.noCamera': "Nessuna fotocamera rilevata. Scegli un'immagine QR.",
    'scan.cameraDenied': 'Accesso alla fotocamera bloccato. Scegli un’immagine QR.',
    'scan.invalid': 'Codice QR o link CYNOOPS LIVE non valido.',
    'scan.imageFailed': 'Nessun codice QR trovato in questa immagine.',
    'loading.title': 'Apertura della sessione in diretta',
    'loading.body': 'Verifica del link sicuro e caricamento della mappa…',
    'error.title': 'Sessione non disponibile',
    'error.invalid': 'Questo link sicuro non è valido.',
    'error.expired': 'Questo link sicuro è scaduto.',
    'error.revoked': 'Questo link sicuro è stato revocato in Command.',
    'error.missing': 'La sessione condivisa non esiste più.',
    'error.network': 'LIVE non riesce a raggiungere la sessione. Controlla la connessione e riprova.',
    'error.generic': 'Impossibile aprire la sessione.',
    'error.retry': 'Riprova',
    'viewer.live': 'In diretta',
    'viewer.ended': 'Terminata',
    'viewer.updating': 'Aggiornamento',
    'viewer.updated': 'Aggiornata {time}',
    'viewer.stale': "Connessione interrotta · visualizzazione dell'ultimo aggiornamento",
    'viewer.mapStyle': 'Stile mappa',
    'viewer.street': 'Strade',
    'viewer.terrain': 'Terreno',
    'viewer.satellite': 'Satellite',
    'viewer.features': 'Elementi',
    'viewer.trackers': 'Tracker',
    'viewer.teams': 'Squadre',
    'viewer.hidePanel': 'Nascondi pannello informazioni',
    'viewer.showPanel': 'Mostra pannello informazioni',
    'viewer.fit': 'Adatta la sessione alla mappa',
    'viewer.closeView': 'Chiudi la vista della sessione live',
    'viewer.closeConfirmTitle': 'Chiudere questa vista live?',
    'viewer.closeConfirmBody': 'Tornerai alla pagina in cui puoi scansionare o importare il codice QR di una sessione. La sessione attiva in Command non verrà interrotta.',
    'viewer.closeConfirmCancel': 'Continua a guardare',
    'viewer.closeConfirmAction': 'Chiudi vista',
    'viewer.emptyFeatures': 'Nessun elemento sulla mappa per questa sessione.',
    'viewer.emptyTrackers': 'Nessun tracker in questa sessione.',
    'viewer.feature': 'Elemento',
    'viewer.tracker': 'Tracker',
    'viewer.team': 'Squadra',
    'viewer.battery': 'Batteria',
    'viewer.speed': 'Velocità',
    'viewer.altitude': 'Altitudine',
    'viewer.lastPosition': 'Ultima posizione',
    'viewer.noPosition': 'In attesa della posizione',
    'viewer.sessionId': 'ID sessione',
    'viewer.started': 'Avviata',
    'viewer.finished': 'Terminata',
    'viewer.mapUnavailable': 'La configurazione della mappa non è disponibile per questa condivisione.',
    'viewer.mapLoading': 'Caricamento mappa Mapbox…',
    'viewer.mapError': 'Mapbox non ha potuto caricare la mappa.',
    'time.now': 'adesso',
    'time.seconds': '{count}s fa',
    'time.minutes': '{count}min fa',
    'time.hours': '{count}h fa'
  }
});

export const normalizeLanguage = (value) => {
  const candidate = String(value || '').trim().toLowerCase().split('-')[0];
  return Object.hasOwn(translations, candidate) ? candidate : DEFAULT_LANGUAGE;
};

export const detectLanguage = () => {
  try {
    const stored = localStorage.getItem('cynoops.live.language');
    if (stored) return normalizeLanguage(stored);
  } catch {}
  return normalizeLanguage(typeof navigator !== 'undefined' ? navigator.language : DEFAULT_LANGUAGE);
};

export const translate = (language, key, replacements = {}) => {
  const lang = normalizeLanguage(language);
  const template = translations[lang]?.[key] ?? translations[DEFAULT_LANGUAGE]?.[key] ?? key;
  return String(template).replace(/\{([a-zA-Z0-9_]+)\}/g, (_match, token) => {
    const value = replacements[token];
    return value === undefined || value === null ? '' : String(value);
  });
};

export const formatRelativeTime = (language, value, now = Date.now()) => {
  const timestamp = typeof value === 'number' ? value : Date.parse(value || '');
  if (!Number.isFinite(timestamp)) return '';
  const seconds = Math.max(0, Math.floor((now - timestamp) / 1000));
  if (seconds < 8) return translate(language, 'time.now');
  if (seconds < 60) return translate(language, 'time.seconds', { count: seconds });
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return translate(language, 'time.minutes', { count: minutes });
  return translate(language, 'time.hours', { count: Math.floor(minutes / 60) });
};
